export default "__VITE_ASSET__B80g2z23__"